import React from 'react';
import logo from '../assets/images/icone/logoSusanOliveira.png';
import '../assets/styles/header.css';

const Header = () => {
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <h1 className="header-title">
          <button 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
            className="logo-button"
          >
            <img 
              src={logo} 
              alt="Susan Oliveira Photography Logo" 
              className="header-logo"
              width="180"
              height="auto"
              loading="eager"
            />
          </button>
        </h1>
        
        <nav className="nav-menu">
          <ul className="nav-list">
            <li className="nav-item">
              <button 
                onClick={() => scrollToSection('portfolio')} 
                className="nav-link"
              >
                Portfolio
              </button>
            </li>
            <li className="nav-item">
              <button 
                onClick={() => scrollToSection('sobre')} 
                className="nav-link"
              >
                About me
              </button>
            </li>
            <li className="nav-item">
              <button 
                onClick={() => scrollToSection('footer')} 
                className="nav-link contact-link"
              >
                Contact
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;